import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/51934442759?text=Hola, me gustaría agendar una cita`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default WhatsAppButton;
